import React from 'react';

import Portal from '../../../../../Shared/React/js/components/Portal';

interface Props {
    title: string;
    onClick: () => void;
}

const ShowFiltersButtonSm = (props: Props) => {
    const mountToNode = document.querySelector('div#show-filters-button-sm');
    return mountToNode ? (
        <Portal mountToNode={mountToNode}>
            <button type="button" className="btn btn-block btn-sm btn-default font-4" onClick={props.onClick}>
                <span className="fa fa-sliders display-inline-block mar-r-3 align-middle"></span>
                {props.title}
            </button>
        </Portal>
    ) : null;
};

export default ShowFiltersButtonSm;
